import PropTypes from 'prop-types';
import React from 'react';
import ListGroup from 'react-bootstrap/lib/ListGroup';
import ListGroupItem from 'react-bootstrap/lib/ListGroupItem';
import Button from 'react-bootstrap/lib/Button';
import Loader from 'components/Loader/Loader';
import styles from './PublicQuestions.module.scss';

const PublicQuestions = ({
  askingQuestion,
  isOwner,
  loadedQuestions,
  loadingQuestions,
  loggedIn,
  moreQuestions,
  onAskQuestion,
  onEdit,
  onLoadMore,
  onPostQuestion,
  onUpdateQuestionText,
  ownQuestions,
  postingQuestion,
  questions,
  questionText,
  ...rest
}) => {
  return (
    <ListGroup {...rest} className={styles.publicQuestionsContainer}>
      <ListGroupItem className="cf">
        <strong className="fs-16 lato-bold" style={{ lineHeight: '33px' }}>
          Public questions
        </strong>
        {!isOwner && !askingQuestion && (
          <Button
            bsStyle="info"
            className="right"
            onClick={() => onAskQuestion(true)}
          >
            Ask a question
          </Button>
        )}
      </ListGroupItem>
      {!askingQuestion && [
        ownQuestions.length > 0
          ? ownQuestions.map((question) => (
              <ListGroupItem key={'question_' + question.id}>
                <p
                  style={{ fontFamily: 'Lato' }}
                  className="no-margin word-wrap"
                >
                  <strong>Q: {question.question}</strong>{' '}
                  {isOwner && (
                    <em>
                      <a
                        onClick={onEdit.bind(null, question.id)}
                        className="pointer"
                      >
                        edit answer
                      </a>
                    </em>
                  )}
                </p>
                <p
                  style={{ fontFamily: 'Lato' }}
                  className="no-margin word-wrap"
                >
                  A:{' '}
                  {question.answer !== '' ? (
                    question.answer
                  ) : (
                    <em>Not answered yet</em>
                  )}
                </p>
              </ListGroupItem>
            ))
          : null,
        questions.length > 0
          ? questions.map((question) => (
              <ListGroupItem key={'question_' + question.id}>
                <p
                  style={{ fontFamily: 'Lato' }}
                  className="no-margin word-wrap"
                >
                  <strong>Q: {question.question}</strong>{' '}
                  {isOwner && (
                    <em>
                      <a
                        onClick={onEdit.bind(null, question.id)}
                        className="pointer"
                      >
                        edit answer
                      </a>
                    </em>
                  )}
                </p>
                <p
                  style={{ fontFamily: 'Lato' }}
                  className="no-margin word-wrap"
                >
                  A:{' '}
                  {question.answer !== '' ? (
                    question.answer
                  ) : (
                    <em>Not answered yet</em>
                  )}
                </p>
              </ListGroupItem>
            ))
          : null,
        loadingQuestions ? (
          <ListGroupItem key="1">
            <Loader loading />
          </ListGroupItem>
        ) : null,
        loadedQuestions &&
        questions.length === 0 &&
        ownQuestions.length === 0 ? (
          <ListGroupItem key="2">
            <em>No questions have been answered yet</em>
          </ListGroupItem>
        ) : null,
        !loadingQuestions && moreQuestions ? (
          <ListGroupItem className="text-center" key="3">
            <a className="pointer" onClick={onLoadMore}>
              <em>More questions...</em>
            </a>
          </ListGroupItem>
        ) : null,
      ]}
      {askingQuestion ? (
        <ListGroupItem className="cf">
          <p style={{ fontFamily: 'Lato' }}>
            Public questions are anonymous and appear under the job details once
            answered.
          </p>
          <p style={{ fontFamily: 'Lato' }}>
            ✅&nbsp;&nbsp;&nbsp;Do: Ask for more detail about the job
          </p>
          <p style={{ fontFamily: 'Lato' }}>
            ❌&nbsp;&nbsp;&nbsp;Don't: Ask questions to self-promote or apply
            for the job
          </p>
          <p style={{ fontFamily: 'Lato' }}>
            Use the{' '}
            <a
              href="https://help.twine.net/en/article/what-are-public-questions-1iawxu6/"
              target="_blank"
            >
              Help Center
            </a>{' '}
            to learn more.
          </p>
          <textarea
            rows="4"
            className="form-control"
            maxLength="250"
            placeholder={
              loggedIn
                ? 'Type your anonymous question to the client here'
                : 'Sign in to ask a question'
            }
            disabled={postingQuestion || !loggedIn}
            value={questionText}
            onChange={onUpdateQuestionText}
          />
          {questionText.length > 200 && (
            <div>
              <em>Characters left: {250 - questionText.length}</em>
            </div>
          )}
          <Button
            className="right mt pr++ pl++"
            onClick={
              loggedIn ? onPostQuestion : () => (document.location = '/signin')
            }
            bsStyle="success"
            disabled={postingQuestion || (loggedIn && questionText === '')}
          >
            {loggedIn ? 'Ask question' : 'Sign in to ask'}
          </Button>
          <Button
            bsStyle="info"
            className="right mt mr"
            onClick={() => onAskQuestion(false)}
          >
            Cancel
          </Button>
        </ListGroupItem>
      ) : null}
    </ListGroup>
  );
};

PublicQuestions.propTypes = {
  questions: PropTypes.array,
  loadingQuestions: PropTypes.bool,
  loadedQuestions: PropTypes.bool,
  onLoadMore: PropTypes.func,
  moreQuestions: PropTypes.bool,
  postingQuestion: PropTypes.bool,
  questionText: PropTypes.string,
  onUpdateQuestionText: PropTypes.func,
  onPostQuestion: PropTypes.func,
  loggedIn: PropTypes.bool,
  isOwner: PropTypes.bool,
  onEdit: PropTypes.func,
  className: PropTypes.string,
};

export default PublicQuestions;
